define(["require", "exports", "knockout"], function (require, exports, ko) {
    "use strict";
    var CustomerImageModel = /** @class */ (function () {
        function CustomerImageModel(data) {
            this.Id = ko.observable(0);
            this.CustomerId = ko.observable(0);
            this.LocationId = ko.observable(0);
            this.Description = ko.observable("");
            var self = this;
            if (data) {
                ko.mapping.fromJS(data, CustomerImageModel.Mapping, self);
            }
        }
        CustomerImageModel.Mapping = {
            key: function (data) {
                return data.Id;
            },
            create: function (options) {
                return new CustomerImageModel(options.data);
            }
        };
        return CustomerImageModel;
    }());
    return CustomerImageModel;
});
//# sourceMappingURL=CustomerImageModel.js.map


//////////////////
// WEBPACK FOOTER
// ./build/models/CustomerImageModel.js
// module id = 166
// module chunks = 2